<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-space-around>
        <v-flex>
            <v-btn @click="signOut">Logout</v-btn>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
import firebase from 'firebase'
export default{
  name: 'Logout',
  methods:{
       signOut: function(){
        firebase.auth().signOut()
        this.$store.commit('setUser', null)
        this.$router.push("/Login")
      },
  }
}


</script>


<style>

</style>
